import { render } from "./PropertyText.vue?vue&type=template&id=ad811c36&scoped=true"
import script from "./PropertyText.vue?vue&type=script&lang=js"
export * from "./PropertyText.vue?vue&type=script&lang=js"

import "./PropertyText.vue?vue&type=style&index=0&id=ad811c36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad811c36"]])

export default __exports__